import { useEffect, useState } from 'react';
import ContentLoader from 'react-content-loader';

interface PlansSkeleton {
	counts: number;
}

const PlansSkeleton = ({ counts }: PlansSkeleton) => {
	const [planCounts, setPlanCounts]: any = useState([]);

	useEffect(() => {
		const plans = [];
		for (let i = 1; i <= counts; i++) {
			plans.push(i);
		}

		setPlanCounts(plans);
	}, []);

	return (
		<>
			{planCounts.map((index: number) => {
				return (
					<ContentLoader key={index} viewBox="0 0 400 50">
						<rect x="0" y="0" width="400" height="1" rx="4"></rect>
						<rect x="0" y="37" width="400" height="1" rx="4"></rect>

						<rect x="0" y="0" width="1" height="38" rx="4"></rect>
						<rect x="399" y="0" width="1" height="38" rx="4"></rect>

						<rect x="10" y="12" width="330" height="15" rx="3"></rect>
						<rect x="360" y="9" width="20" height="20" rx="50"></rect>
					</ContentLoader>
				);
			})}
		</>
	);
};

export default PlansSkeleton;
